module.exports = {
      id: "comm-video-usage",
      viewBox: "0 0 276.069 41.984",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#comm-video",
      toString: function () {
        return this.url;
      }
    }